import { Pipe, PipeTransform } from '@angular/core';
import { ReviewTargetModel } from '@models/reviewTarget.model';

@Pipe({
  name: 'isZillow'
})
export class IsZillowPipe implements PipeTransform{

  transform(reviewTarget: ReviewTargetModel): boolean {
    return !!reviewTarget.name && reviewTarget.name.toLowerCase().includes('zillow');
  }

}
